import React from "react";
import { Box, Chip, IconButton, Typography, makeStyles } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { ChannelIcon } from "../ChannelConnectionLabel";

const useStyles = makeStyles((theme) => ({
  card: {
    border: `1px solid ${theme.mode === "dark" ? "#334155" : "#e5e7eb"}`,
    borderRadius: 14,
    padding: 14,
    cursor: "pointer",
    backgroundColor: theme.palette.background.paper,
    minHeight: 148,
    display: "flex",
    flexDirection: "column",
    gap: 8,
    transition: "box-shadow 0.15s ease, transform 0.15s ease",
    "&:hover": {
      boxShadow: theme.mode === "dark" ? "0 8px 24px rgba(0,0,0,0.35)" : "0 8px 24px rgba(15,23,42,0.08)",
      transform: "translateY(-1px)",
    },
  },
  name: {
    fontWeight: 800,
    fontSize: 15,
    lineHeight: 1.25,
  },
  meta: {
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
  connection: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontSize: 13,
    color: theme.palette.text.secondary,
  },
  footer: {
    marginTop: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 4,
  },
}));

const CampaignCard = ({
  name,
  dateLabel,
  connectionName,
  countLabel,
  statusChip,
  onOpen,
  actions,
  channel,
}) => {
  const classes = useStyles();

  return (
    <Box className={`${classes.card} channel-hover`} onClick={onOpen}>
      <Typography className={classes.name}>{name}</Typography>
      {dateLabel ? <Typography className={classes.meta}>{dateLabel}</Typography> : null}
      <Typography className={classes.connection}>
        <ChannelIcon channel={channel} />
        {connectionName || "Sin conexión"}
      </Typography>
      <Box className={classes.footer}>
        <Typography className={classes.meta}>{countLabel}</Typography>
        <Box display="flex" alignItems="center" style={{ gap: 4 }}>
          {statusChip}
          <IconButton size="small" onClick={(e) => { e.stopPropagation(); onOpen(e); }}>
            <VisibilityIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>
      {actions ? (
        <Box className={classes.actions} onClick={(e) => e.stopPropagation()}>
          {actions}
        </Box>
      ) : null}
    </Box>
  );
};

export default CampaignCard;
